"use-strict";

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

var BlsAnimations = (function () {
  return {
    innit: function () {
      this.animates();
    },
    animates: function () {
      var animates = document.querySelectorAll(".scroll-trigger");
      if (animates.length > 0) {
        animates.forEach((i) => {
          i.addEventListener("animationend", (e) => {
            setTimeout(() => {
              e.target.setAttribute("animation-end", "");
            }, 1000);
          });
        });
      }
    },
  };
})();

let parser = new DOMParser();

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
};

class SlideSection extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.init();
  }

  init() {
    if (document.body.classList.contains("index")) {
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains("swiper-lazy")) {
        this.initSlide();
      } else {
        if (this.classList.contains("lazy-loading-swiper-before")) {
          this.initSlide();
        } else {
          this.classList.add("lazy-loading-swiper-after");
        }
      }
    } else {
      this.initSlide();
    }
  }

  initSlide() {
    const _this = this;
    const parentElement = this?.dataset?.parent
      ? _this.closest(this?.dataset?.parent)
      : null;
    let next = _this.querySelector(
      ".swiper-button-next, .swiper-button-next-layout2"
    );
    let back = _this.querySelector(
      ".swiper-button-prev, .swiper-button-prev-layout2"
    );

    if (parentElement) {
      next =
        parentElement.querySelector(
          ".swiper-button-next, .swiper-button-next-layout2"
        ) ||
        document.querySelector(
          ".section__header .swiper-button-next, .section__header .swiper-button-next-layout2"
        );
      back =
        parentElement.querySelector(
          ".swiper-button-prev, .swiper-button-prev-layout2"
        ) ||
        document.querySelector(
          ".section__header .swiper-button-prev, .section__header .swiper-button-prev-layout2"
        );
    }

    const hasNavigation = next && back;
    console.log("Navigation buttons:", next, back);

    let paginationEl;
    let hasPagination = false;
    const showDotHeading = _this?.dataset.showDotHeading === "true";
    if (showDotHeading) {
      const sectionId = _this.id;
    }
    if (!paginationEl) {
      paginationEl = _this.querySelector(".swiper-pagination");
    }

    if (!paginationEl) {
      paginationEl = _this.querySelector(".swiper-pagination");
    }

    hasPagination = !!paginationEl;
    console.log("[SlideSection] Pagination element:", paginationEl);

    const loop = _this?.dataset.loop === "true";
    const mousewheel = _this?.dataset.mousewheel === "true";
    const numberpagination = _this?.dataset.numberpagination === "true";
    const paginationFraction = _this?.dataset.paginationFraction === "true";
    const itemDesktop = _this?.dataset.desktop ? _this.dataset.desktop : 4;
    const initialSlide = _this?.dataset.initialSlide
      ? parseInt(_this.dataset.initialSlide)
      : 0;
    let itemTablet = _this?.dataset.tablet
      ? parseInt(_this.dataset.tablet)
      : "";
    const itemMobile = _this?.dataset.mobile ? _this.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    let autoplaySpeed = _this?.dataset.autoplaySpeed
      ? parseInt(_this.dataset.autoplaySpeed) * 1000
      : 3000;
    let speed = _this?.dataset.speed ? parseInt(_this.dataset.speed) : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? parseInt(_this.dataset.row) : 1;
    let spacing = _this?.dataset.spacing ? parseInt(_this.dataset.spacing) : 30;
    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    let autoplaying = _this?.dataset.autoplay === "true";

    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }

    const showLayout3 = _this?.dataset.showLayout3 === "true";

    const initializeSwiper = () => {
      let enableCustomBullet =
        window.innerWidth < 767.98
          ? false
          : _this?.dataset.enableCustomBullet === "true";

      let paginationConfig = {
        clickable: true,
      };

      if (hasPagination) {
        paginationConfig.el = paginationEl;
      }
      if (paginationFraction) {
        paginationConfig.type = "fraction";

        paginationConfig.formatFractionCurrent = (num) => num;
        paginationConfig.formatFractionTotal = (num) => num;
      } else {
        paginationConfig.type = progressbar ? "progressbar" : "bullets";

        if (
          enableCustomBullet &&
          !progressbar &&
          hasPagination &&
          numberpagination === false
        ) {
          paginationConfig.renderBullet = function (index, className) {
            return `
              <button class="${className}">
                <svg class="progress" width="25" height="25">
                  <circle class="circle-base" r="10" cx="12.5" cy="12.5"></circle>
                  <circle class="circle-progress" r="10" cx="12.5" cy="12.5"></circle>
                </svg>
              </button>
            `;
          };
        } else if (!progressbar && hasPagination && numberpagination === true) {
          paginationConfig.renderBullet = function (index, className) {
            const num = ("0" + (index + 1)).slice(-2);
            return `<span class="${className} swiper-pagination-number">${num}</span>`;
          };
        } else {
          delete paginationConfig.renderBullet;
        }
      }

      const navigationConfig = {};
      if (hasNavigation) {
        navigationConfig.nextEl = next;
        navigationConfig.prevEl = back;
      }

      if (this.globalSlide && this.globalSlide.destroy) {
        this.globalSlide.destroy(true, true);
      }

      const swiperWrapper = _this.querySelector(".swiper-wrapper");
      if (!swiperWrapper) {
        console.warn(
          "Swiper wrapper (.swiper-wrapper) not found within SlideSection."
        );
        return;
      }

      this.globalSlide = new Swiper(_this, {
        slidesPerView: autoItem ? "auto" : itemMobile,
        spaceBetween: spacing >= 15 ? 15 : spacing,
        autoplay: autoplaying,
        direction: direction,
        centeredSlides: showLayout3,
        loop: loop,
        effect: effect,
        speed: speed,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        mousewheel: mousewheel,
        initialSlide: initialSlide,
        grid: {
          rows: row,
          fill: "row",
        },
        ...(hasNavigation && { navigation: navigationConfig }),
        ...(hasPagination && { pagination: paginationConfig }),
        breakpoints: {
          768: {
            slidesPerView: itemTablet,
            spaceBetween: spacing >= 30 ? 30 : spacing,
          },
          1025: {
            slidesPerView: itemDesktop,
            spaceBetween: spacing,
          },
        },
        thumbs: {
          swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
        },

        on: {
          init: function () {
            var sec__tiktok = _this.closest(".sec__tiktok-video");
            if (sec__tiktok) {
              _this.initSecTiktok(sec__tiktok);
              window.addEventListener("resize", function () {
                setTimeout(() => {
                  _this.initSecTiktok(sec__tiktok);
                }, 150);
              });
            }
            if (arrowCenterimage) {
              var items_slide = _this.querySelectorAll(
                ".product-item__media--ratio"
              );
              if (items_slide.length != 0) {
                var oH = [];
                items_slide.forEach((e) => {
                  oH.push(e.offsetHeight / 2);
                });
                var max = Math.max(...oH);
                var arrowsOffset = "--arrows-offset-top: " + max + "px";
                if (_this.querySelectorAll(".swiper-arrow")) {
                  _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                    arrow.setAttribute("style", arrowsOffset);
                  });
                }
              }
            }
            var video = _this.querySelector("video.slideshow");
            if (video) {
              const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(_this);
                const videos = _this.querySelectorAll("video");
                window.addEventListener("resize", (e) => {
                  videos.forEach((video) => {
                    const posterDesktop = video.dataset.posterdesktop;
                    const postermobile = video.dataset.postermobile;
                    const width = window.innerWidth;
                    if (posterDesktop && postermobile) {
                      if (width > 768) {
                        video.poster = `${posterDesktop}`;
                      } else {
                        video.poster = `${postermobile}`;
                      }
                    }
                  });
                });
                videos.forEach((video) => {
                  const dataSrc = video.dataset.src;
                  const posterDesktop = video.dataset.posterdesktop;
                  const postermobile = video.dataset.postermobile;
                  const width = window.innerWidth;

                  if (dataSrc) {
                    video.src = dataSrc;
                    if (posterDesktop && postermobile) {
                      if (width > 768) {
                        video.poster = `${posterDesktop}`;
                      } else {
                        video.poster = `${postermobile}`;
                      }
                    }
                    video.removeAttribute("data-src");
                  }
                });
              };
              new IntersectionObserver(handleIntersection.bind(_this), {
                rootMargin: "0px 0px 200px 0px",
              }).observe(_this);
            }
            var swiper = this;
            if (swiper.pagination && swiper.pagination.bullets) {
              var bullets = swiper.pagination.bullets;

              bullets.forEach((bullet, index) => {
                bullet.addEventListener("click", function () {
                  bullets.forEach((b) => {
                    b.classList.remove("active");
                  });

                  if (!swiper._toggleState) {
                    swiper._toggleState = false;
                  }
                  swiper._toggleState = !swiper._toggleState;

                  bullet.classList.add("active");
                });
              });
            }
          },
          slideChange: function () {
            const index_currentSlide = this.realIndex + 1;

            if (_this.closest(".sec__testimonials-single")) {
              const allDots = _this
                .closest(".sec__testimonials-single")
                .querySelectorAll(`single-item`);
              allDots.forEach((dot) => {
                dot.classList.remove("active");
              });
              _this
                .closest(".sec__testimonials-single")
                .querySelector(
                  ".testimonials-author-image[data-position='" +
                    index_currentSlide +
                    "']"
                )
                .classList.add("active");
            }

            if (this.pagination && this.pagination.bullets) {
              const bullets = this.pagination.bullets;
              bullets.forEach((bullet) => {
                bullet.classList.remove("active");
              });

              const activeBullet = bullets[this.realIndex];
              if (activeBullet) {
                activeBullet.classList.add("active");
              }
            }
          },
        },
      });
    };

    initializeSwiper();

    window.addEventListener("resize", () => {
      initializeSwiper();
    });

    document.addEventListener("shopify:section:load", () => {
      initializeSwiper();
    });
    document.addEventListener("shopify:section:reorder", () => {
      initializeSwiper();
    });

    document.addEventListener("shopify:section:unload", () => {
      initializeSwiper();
    });

    document.addEventListener("shopify:section:select", () => {
      initializeSwiper();
    });
  }

  initSecTiktok(sec) {
    sec.querySelectorAll(".swiper-slide").forEach((arrow) => {
      const tiktok = arrow.querySelector(".section_tiktok-image");
      let width = "--item-width: " + arrow.offsetWidth;
      tiktok.setAttribute("style", width);
    });
  }
}

customElements.define("slide-section", SlideSection);

class PopupBase extends HTMLElement {
  constructor() {
    super();
    this.customClass = this.dataset.customClass;
    this.modal = null;
  }

  initPopup(content, text, customClass) {
    const _this = this;
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      cssClass: [this.customClass || customClass],
      onOpen: function () {
        const video = this.modalBox.querySelector("video");
        if (!video) return;
        video.play();
        if (this.modal.classList.contains("shopable-video")) {
          video.muted = false;
        }
      },
      onClose: function () {},
      beforeClose: function () {
        _this.onCloseEvent();
        return true;
      },
    });
    this.modal.setHeader = function (content) {
      let popup_content = this.modalBoxContent;
      let popup_header = document.createElement("div");
      popup_header.classList.add("tingle-modal-box__header");
      popup_header.innerHTML = content;
      let parentElement = popup_content.parentNode;
      parentElement.insertBefore(popup_header, popup_content);
    };
    if (text) {
      this.modal.setHeader(text);
    }

    this.modal.setContent(content);
    this.modal.open();
  }

  onClose() {
    this.modal.close();
  }
  onCloseEvent() {}
}

class SwatchInit extends HTMLElement {
  constructor() {
    super();
    this.options = null;
    this.init();
  }

  init() {
    const _this = this;
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      _this.checkSwatches(btn);
    });
  }
  checkSwatches(e) {
    const { color, image, customValue, swatchType, optionSwatchValue } =
      e.dataset;
    if (color) {
      if (swatchType != "variant_images") {
        if (optionSwatchValue.length == 0 || optionSwatchValue == null) {
          if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
            if (image) {
              e.classList.add("color__" + color.replace(" ", "-"));
              e.style.backgroundColor = null;
              e.style.backgroundImage = "url('" + image + "')";
              e.style.backgroundSize = "cover";
              e.style.backgroundRepeat = "no-repeat";
            }
          }
        } else {
          e.style.setProperty("--swatch--background", optionSwatchValue);
        }
      } else {
        if (optionSwatchValue.length == 0 || optionSwatchValue == null) {
          if (image) {
            e.classList.add("color__" + color.replace(" ", "-"));
            e.style.backgroundColor = null;
            e.style.backgroundImage = "url('" + image + "')";
            e.style.backgroundSize = "cover";
            e.style.backgroundRepeat = "no-repeat";
          } else if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
          }
        } else {
          e.style.setProperty("--swatch--background", optionSwatchValue);
        }
      }
    }
  }
  checkColor(strColor) {
    var s = new Option().style;
    s.color = strColor;
    return s.color == strColor;
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll(".product__color-swatches--js.active"),
      (select) => select.getAttribute("data-value")
    );
    this.variantData.find((variant) => {
      if (this.options.length == 1) {
        const variantOptions = {
          1: variant.option1,
          2: variant.option2,
          3: variant.option3,
        };
        if (variantOptions[this.position_swatch] === this.options[0]) {
          this.options = variant.options;
        }
      }
    });
  }
  updateMasterId(variantData) {
    return (this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    }));
  }
}

// js for 3d product - not done yet
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        deferredElement.play();
      }
    }
  }
}

function handleErrorMessagePopup(errorMessage = false) {
  const url = `${window.location.pathname}?section_id=form-message`;
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const elementErrorMessage = html.querySelector(
        ".product-form__error-message-wrapper"
      );
      const elementMessage = elementErrorMessage.querySelector(
        ".product-form__error-message"
      );
      elementMessage.textContent = errorMessage;
      showToast(elementErrorMessage.innerHTML, 5000, "modal-error");
    })
    .catch((e) => {
      throw e;
    });
}

function showToast(message, duration = 3000, customClass = "") {
  let toastContainer = document.getElementById("toast-container");
  if (!toastContainer) {
    toastContainer = document.createElement("div");
    toastContainer.id = "toast-container";
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement("div");
  toast.className = `toast show ${customClass}`;
  toast.innerHTML = message;
  toastContainer.appendChild(toast);

  setTimeout(() => {
    closeToast(toast);
  }, duration);
}

function closeToast(toast) {
  toast.classList.remove("show");
  setTimeout(() => {
    toast.remove();
    if (!document.querySelector("#toast-container .toast")) {
      document.getElementById("toast-container").remove();
    }
  }, 500);
}

class SlideLazyLoad {
  constructor(e) {
    (this.triggerEventsJs = e),
      (this.eventOptionsJs = { passive: !0 }),
      (this.userEventListenerJs = this.triggerListenerJs.bind(this)),
      (this.delayedScriptsJs = { normal: [], async: [], defer: [] });
  }
  triggerListenerJs() {
    this._removeUserInteractionListenerJs(this),
      "loading" === document.readyState
        ? document.addEventListener(
            "DOMContentLoaded",
            this._loadEverythingReadyNow.bind(this)
          )
        : this._loadEverythingReadyNow();
  }
  _removeUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach((t) =>
      window.removeEventListener(t, e.userEventListenerJs, e.eventOptionsJs)
    );
  }
  _addUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach((t) =>
      window.addEventListener(t, e.userEventListenerJs, e.eventOptionsJs)
    );
  }
  _preloadAllScriptsJs() {
    document.body.classList.add("swiper-lazy");
    document.body.classList.add("review-lazy");
    const loadingSwiper = document.querySelectorAll(
      ".lazy-loading-swiper-after"
    );
    loadingSwiper.forEach((el) => {
      el.classList.remove("lazy-loading-swiper-after");

      this.initSlide(el);
    });
    const reviewProduct = document.querySelectorAll(".review-product-added");
    reviewProduct.forEach((el) => {
      el.classList.remove("review-product-added");
      el.innerHTML = el.querySelector(".product-review-json").innerHTML;
      el.classList.remove("inline-loading");
    });
  }

  initSlide(el) {
    const _this = el;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const parentElement = _this?.dataset?.parent
      ? _this.closest(_this?.dataset?.parent)
      : null;
    let next = _this.querySelector(".swiper-button-next");
    let back = _this.querySelector(".swiper-button-prev");
    if (parentElement) {
      next = parentElement.querySelector(".swiper-button-next");
      back = parentElement.querySelector(".swiper-button-prev");
    }
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: next,
        prevEl: back,
      },
      pagination: {
        clickable: true,
        el: _this.querySelector(".swiper-pagination"),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function () {
          var sec__tiktok = _this.closest(".sec__tiktok-video");
          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener("resize", function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.closest(".sec__testimonials-single")) {
            const allDots = _this
              .closest(".sec__testimonials-single")
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove("active");
            });
            _this
              .closest(".sec__testimonials-single")
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']"
              )
              .classList.add("active");
          }
        },
      },
    });
  }

  async _loadEverythingReadyNow() {
    this._preloadAllScriptsJs(),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.normal),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.defer),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.async),
      await this._triggerDOMContentLoadedJs(),
      await this._triggerWindowLoadJs(),
      window.dispatchEvent(new Event("woomenspeed-allScriptsLoaded"));
  }
  async _loadScriptsFromListJs(e) {
    const t = e.shift();
    return t
      ? (await this._transformScript(t), this._loadScriptsFromListJs(e))
      : Promise.resolve();
  }
  async _transformScript(e) {
    return (
      await this._requestAnimFrame(),
      new Promise((t) => {
        const s = document.createElement("script");
        let n;
        [...e.attributes].forEach((e) => {
          let t = e.nodeName;
          "type" !== t &&
            ("data-woomenlazy-type" === t && ((t = "type"), (n = e.nodeValue)),
            s.setAttribute(t, e.nodeValue));
        }),
          e.hasAttribute("src")
            ? (s.addEventListener("load", t), s.addEventListener("error", t))
            : ((s.text = e.text), t()),
          e.parentNode.replaceChild(s, e);
      })
    );
  }
  async _triggerDOMContentLoadedJs() {
    (this.domReadyFired = !0),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event("woomenspeed-DOMContentLoaded")),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event("woomenspeed-DOMContentLoaded")),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event("woomenspeed-readystatechange")),
      await this._requestAnimFrame(),
      document.woomenonreadystatechange && document.woomenonreadystatechange();
  }
  async _triggerWindowLoadJs() {
    await this._requestAnimFrame(),
      window.dispatchEvent(new Event("woomenspeed-load")),
      await this._requestAnimFrame(),
      window.woomenonload && window.woomenonload(),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event("woomenspeed-pageshow")),
      await this._requestAnimFrame(),
      window.woomenonpageshow && window.woomenonpageshow();
  }
  async _requestAnimFrame() {
    return new Promise((e) => requestAnimationFrame(e));
  }
  static run() {
    const e = new SlideLazyLoad([
      "keydown",
      "mousemove",
      "touchmove",
      "touchstart",
      "touchend",
      "wheel",
    ]);
    e._addUserInteractionListenerJs(e);
  }
}
SlideLazyLoad.run();

// js for copy button
class CopyButton extends HTMLElement {
  constructor() {
    super();
    this.content = this.dataset.content;
    this.init();
  }
  init() {
    if (this.content) {
      this.addEventListener("click", this.onClick.bind(this));
    }
  }
  onClick() {
    navigator.clipboard.writeText(this.content);
    this.classList.add("copied");
  }
  updateUrl(newContent) {
    this.content = newContent;
  }
}
customElements.define("copy-button", CopyButton);
